import { ClientOnly, useTheme } from "zudoku/components";
import { MonitorIcon, MoonIcon, SunIcon } from "zudoku/icons";

// Replaces Zudoku's two-state toggle, which pins light or dark in localStorage
// with no way back. next-themes already defaults to "system"; this exposes it.
const MODES = [
  { value: "light", label: "Light", Icon: SunIcon },
  { value: "system", label: "System", Icon: MonitorIcon },
  { value: "dark", label: "Dark", Icon: MoonIcon },
] as const;

const Switch = () => {
  const { theme = "system", setTheme } = useTheme();

  return (
    <div role="radiogroup" aria-label="Colour theme" className="fin-theme-switch">
      {MODES.map(({ value, label, Icon }) => (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={theme === value}
          aria-label={label}
          title={label}
          onClick={() => setTheme(value)}
        >
          <Icon size={14} strokeWidth={1.75} />
        </button>
      ))}
    </div>
  );
};

// The stored choice is only known on the client; render a same-size placeholder
// on the server so the header does not shift on hydration.
export const ThemeModeSwitch = () => (
  <ClientOnly fallback={<div className="fin-theme-switch" aria-hidden />}>
    <Switch />
  </ClientOnly>
);
